import { IconButton, MessageBar, MessageBarType, Stack, Toggle, Text } from '@fluentui/react';
import { fadeIn } from 'global/Application';
import { IEntityReferenceValue } from 'model/FlexibleAttributeModel';
import React from 'react';
import CustomPanel, { EPanelStyleType } from 'views/BlueRelationship/Compare/CustomPanel';
import SnapshotLookup from '../SnapshotLookup';

interface ICompareProps {
    origin?: IEntityReferenceValue;
    target?: IEntityReferenceValue;
    onCancel?: () => void;
    onShowDifferencesOnlyChange: (showDifferencesOnly: boolean) => void;
    showDifferencesOnly?: boolean;
}

const CompareInformation: React.FC<ICompareProps> = (props) => {

    return (
        <CustomPanel title={"Compare Information"}
            styleType={EPanelStyleType.Yellow}
            canCollapse={true}
            defaultCollapsed={false}
            headerRight={props.onCancel && <IconButton
                iconProps={{ iconName: 'Cancel' }}
                title="Cancel comparison"
                ariaLabel="Cancel comparison"
                onClick={(event) => {
                    event.stopPropagation();
                    props.onCancel?.();
                }}
                onKeyDown={(event) => event.stopPropagation()}
            />}
            contentStyle={{ paddingTop: '15px', paddingBottom: '15px' }}
        >
            {(!props.origin && !props.target) && (
                <MessageBar className={fadeIn} messageBarType={MessageBarType.warning} styles={{ root: { marginBottom: '15px' } }}>
                    <Text variant="small">
                        No comparison source has been selected, use compare to specify the origin/target snapshots to compare.
                    </Text>
                </MessageBar>
            )}

            <Stack tokens={{ childrenGap: '15px' }}>
                <Stack horizontal tokens={{ childrenGap: '15px' }}>
                    <Stack.Item grow={1} basis={1}>
                        <SnapshotLookup
                            label='Origin Snapshot'
                            disabled={true}
                            valueSnapshot={props.origin}
                        />
                    </Stack.Item>

                    <Stack.Item grow={1} basis={1}>
                        <SnapshotLookup
                            label='Target Snapshot'
                            disabled={true}
                            valueSnapshot={props.target}
                        />
                    </Stack.Item>
                </Stack>
                <Stack horizontalAlign="end">
                    <Stack.Item>
                        <Toggle
                            label="Show Differences Only"
                            inlineLabel={true}
                            checked={props.showDifferencesOnly}
                            onChange={(e, checked) => {
                                props.onShowDifferencesOnlyChange(checked ?? false);
                            }}
                        />
                    </Stack.Item>
                </Stack>
            </Stack>
        </CustomPanel>
    );

};

export default CompareInformation;